import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { CloseTemplateRow } from "../organizationCloseTemplatesViewConfig";
import styles from "./CloseTemplateTaskCountCell.module.scss";

export const CloseTemplateTaskCountCell = memo(
    ({ row }: CellContext<ViewTableFeatures, CloseTemplateRow, number>) => {
        const count = row.original.taskCount;

        return <ViewTableCell className={styles.cell}>{count}</ViewTableCell>;
    },
);
